import { render, staticRenderFns } from "./AddCarac.vue?vue&type=template&id=42c5ff6e&"
import script from "./AddCarac.vue?vue&type=script&lang=js&"
export * from "./AddCarac.vue?vue&type=script&lang=js&"
import style0 from "./AddCarac.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports